import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { captureConsole } from "./debug/clientLog";
import "./index.css";

// Antes do render: o gate (enableDebug) só se conhece após o check-in, então as linhas ficam
// numa fila até lá. Sem isto, o boot — SSO e check-in, onde os problemas de celular aparecem —
// seria a única parte que nunca chegaria ao log.
captureConsole("shell");

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
